export default "__VITE_ASSET__DOSNdurR__"